import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store';
import axios from 'axios';

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL

// --- AXIOS INTERCEPTOR SETUP ---
axios.interceptors.response.use(
    // If the response is successful, just pass it through
    response => response,
    // If there's an error...
    error => {
      // Check if it's a 401 Unauthorized error
      if (error.response && error.response.status === 401) {
        // If the user was authenticated in the store, force a logout
        if (store.getters.isAuthenticated) {
          store.dispatch('LogOut'); // This will clear the store and redirect
        }
      }
      // Important: Reject the promise to trigger the .catch() block of the original call
      return Promise.reject(error);
    }
);
// -----------------------------

Vue.config.productionTip = false

// --- APP INITIALIZATION ---
// Check auth status BEFORE mounting the app to prevent flickering
store.dispatch('CheckAuth').then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app');
});
